import AllInOne from 'pages/Home/components/AllInOne'
import s from './index.module.scss'
import RegisterAsSidebar from '../components/RegisterAsSidebar'
import { t } from 'helpers'
import { ArrowShortIcon } from 'assets/icons'
import { useNavigate } from 'react-router-dom'
import { PATHS } from 'types/enums'

const Register = (): JSX.Element => {
	const navigate = useNavigate()

	return (
		<>
			<RegisterAsSidebar />
			<div className={s.background}>
				<img src="/login-background.png" />
			</div>
			<div className={s.container}>
				<AllInOne />
				<div className={s.member}>
					<span>{t('APP_ALREADY_MEMBER')}</span>
					<div
						onClick={() => {
							navigate('/' + PATHS.JOIN + '/' + PATHS.LOGIN)
						}}>
						<span className="body1-b">{t('APP_LOGIN')}</span>
						<ArrowShortIcon />
					</div>
				</div>
			</div>
		</>
	)
}

export default Register
